import TimezoneSwitcher from "../../../../components/timezoneSwitcher/TimezoneSwitcher";
import { SettingsRow } from "../settings-row/SettingsRow";

export const TimezoneSelector = ({ className = "" }) => {
    return (
        <SettingsRow labelKey="282" className="settings-timezone-selector" id="timezone-selector">
            <TimezoneSwitcher className={`${className}`} id="timezone-selector-switcher" />
        </SettingsRow>
    )
}

